import { render } from "./Recaptcha.vue?vue&type=template&id=5c8e3351"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__